import { Types } from "../actions/CheckItemGroupExcelActions";

const initialState = {
    excelList: [],
    uploadResponse: {},
};

export const CheckItemGroupExcelReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.CHECKITEMGROUPEXCEL_SET_EXCEL_LIST:
            return {
                ...state,
                excelList: action.payload || state.excelList,
            };
        case Types.CHECKITEMGROUPEXCEL_UPLOAD_FILE:
            return {
                ...state,
                uploadResponse: action.payload || state.uploadResponse,
            };
        default:
            return state;
    }
};
